module.exports = __webpack_public_path__ + "static/media/trekkingBike.61ab1f29.png";